import { AES, enc, lib, mode, pad, PBKDF2 } from 'crypto-js';

export default class Aes256 {
    keySize;
    ivSize;
    saltSize;
    iterations;

    constructor() {
        this.keySize = 256;
        this.ivSize = 128;
        this.saltSize = 256;
        this.iterations = 1000;
    }

    encrypt(text, initialKey) {
        const salt = lib.WordArray.random(this.saltSize / 8);

        const key = PBKDF2(initialKey, salt, {
            keySize: this.keySize / 32,
            iterations: this.iterations,
        });

        const iv = lib.WordArray.random(this.ivSize / 8);

        const encrypted = AES.encrypt(text, key, {
            iv,
            padding: pad.Pkcs7,
            mode: mode.CBC,
        });

        const encryptedHex = this.base64ToHex(encrypted.toString());
        const base64result = this.hexToBase64(salt.toString() + iv.toString() + encryptedHex);

        return base64result;
    }

    decrypt(text, initialKey) {
        const hexResult = this.base64ToHex(text);

        const salt = enc.Hex.parse(hexResult.substr(0, 64));
        const iv = enc.Hex.parse(hexResult.substr(64, 32));
        const encrypted = this.hexToBase64(hexResult.substring(96));

        const key = PBKDF2(initialKey, salt, {
            keySize: this.keySize / 32,
            iterations: this.iterations,
        });

        const decrypted = AES.decrypt(encrypted, key, {
            iv,
            padding: pad.Pkcs7,
            mode: mode.CBC,
        });

        return decrypted.toString(enc.Utf8);
    }

    hexToBase64(text) {
        return btoa(
            String.fromCharCode.apply(
                null,
                text
                    .replace(/\r|\n/g, '')
                    .replace(/([\da-fA-F]{2}) ?/g, '0x$1 ')
                    .replace(/ +$/, '')
                    .split(' ')
            )
        );
    }

    base64ToHex(text) {
        const bin = atob(text.replace(/[ \r\n]+$/, ''));
        const hex = [];
        for (let i = 0; i < bin.length; ++i) {
            let tmp = bin.charCodeAt(i).toString(16);
            if (tmp.length === 1) tmp = '0' + tmp;
            hex[hex.length] = tmp;
        }
        return hex.join('');
    }
}
